import { createContext, useState, useContext, useEffect, useCallback } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";

const CartContext = createContext();
import { API_BASE as API } from "@/config/api";

export const CartProvider = ({ children }) => {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], total: 0, item_count: 0 });

  const fetchCart = useCallback(async () => {
    if (!user) { setCart({ items: [], total: 0, item_count: 0 }); return; }
    try {
      const { data } = await axios.get(`${API}/cart`, { withCredentials: true });
      setCart(data);
    } catch (e) { console.error("Cart fetch error", e); }
  }, [user]);

  useEffect(() => { fetchCart(); }, [fetchCart]);

  const addToCart = async (productId, quantity = 1, customNote = "") => {
    await axios.post(`${API}/cart`, { product_id: productId, quantity, custom_note: customNote }, { withCredentials: true });
    await fetchCart();
  };

  const removeFromCart = async (productId) => {
    await axios.delete(`${API}/cart/${productId}`, { withCredentials: true });
    await fetchCart();
  };

  const updateQuantity = async (productId, quantity) => {
    await axios.put(`${API}/cart/${productId}`, { quantity }, { withCredentials: true });
    await fetchCart();
  };

  const clearCart = async () => {
    await axios.delete(`${API}/cart`, { withCredentials: true });
    setCart({ items: [], total: 0, item_count: 0 });
  };

  return (
    <CartContext.Provider value={{ cart, fetchCart, addToCart, removeFromCart, updateQuantity, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
